export const USERS = {
    "victorfurtyy": {
        desc: "Carlos Victor",
        img: "https://www.dropbox.com/scl/fi/ii7wjbosdojxd7bxdiny2/IMG_2030.JPG?rlkey=9zqqw38ds0nc56igb870lrj7m&st=56e3rent&raw=1"
    },
    "arauujobeatriz": {
        desc: "Ana Beatriz",
        img: "https://www.dropbox.com/scl/fi/kkaldelhd8qcz2lx4xuxg/IMG_2031.jpg?rlkey=s13rb9erbugossfuy0435wu3e&st=4s06m0jk&raw=1"
    },
    "norman": {
        desc: "Norman",
        img: "https://www.dropbox.com/scl/fi/a0o41wa4g5k8kbeu5gbqo/6b412ad1-3d30-4487-9f3e-f57bc6a42ffd.jpeg?rlkey=ootidccg4sh6trdn3sjj1yqio&st=3737dmpo&raw=1"
    },
    "furtadoirlene": {
        desc: "Irlene Furtado",
        img: "https://www.dropbox.com/scl/fi/76980j6xvfp8c2sckbvt9/IMG_1989.jpg?rlkey=g9ky2rht4crv2egyffesy2pc5&st=xnm2ix3l&raw=1"
    },
    "antoniojorge10_": {
        desc: "Antônio Jorge",
        img: "https://www.dropbox.com/scl/fi/37xr2qf9gyc3180urzdp4/IMG_1971.jpg?rlkey=q90jd1ejhhk5yuz9p7bmrvkx9&st=050pnub2&raw=1"
    },
    "leticiafeba_": {
        desc: "Lê",
        img: "https://www.dropbox.com/scl/fi/ifkelxlvuuq18gfmw8ecv/IMG_1946.jpg?rlkey=c3dtkdhz1z1i3i8ygtx1y9nee&st=gbshuc27&raw=1"
    },
    "_manu_marques": {
        desc: "Manu",
        img: "https://www.dropbox.com/scl/fi/p0b1m76p4rzsqy625me0g/IMG_1955.jpg?rlkey=lte4rhc4hu9nylzxuyulf7v4a&st=k8sykay7&raw=1"
    },
    "anarfls": {
        desc: "Ana Frozenha",
        img: "https://www.dropbox.com/scl/fi/ttfgh5xj5wr03tbjh6o1t/IMG_2038.jpg?rlkey=beqewjpi9cyncw05d1vhoh3iq&st=t7s5eth5&raw=1"
    },
    "jdeliciaa": {
        desc: "Jota Delícia",
        img: "https://www.dropbox.com/scl/fi/2y98k717arkh8bdagi5ve/IMG_2013.jpg?rlkey=b8pfqj3apzl5pefvz39hvoi5x&st=voa7k3di&raw=1"
    },
    "josifurtado6": {
        desc: "Joyce",
        img: "https://www.dropbox.com/scl/fi/9i69xo4ots1ynviokgt97/IMG_1961.jpg?rlkey=nvdljkk7ekkh6aubo2bpq004a&st=3wq8aqdl&raw=1"
    },
    "mariane": {
        desc: "Mariane",
        img: "https://www.dropbox.com/scl/fi/stl60fd2ja3k3pdzk6kcb/IMG_1962.jpg?rlkey=q5poofl9cri0py484lwfcrp8o&st=yrjcf3xa&raw=1"
    },
    "artzssw.jg": {
        desc: "Arthur",
        img: "https://www.dropbox.com/scl/fi/335gjb1xwbt5e6z4mt72o/IMG_2043.jpg?rlkey=jq63anl37crz6vdn4fx4slqfu&st=w0yiv744&raw=1"
    },
    "joanadarcfurtado_": {
        desc: "Joana D'arc",
        img: "https://www.dropbox.com/scl/fi/s7ztaa4rheh9epxbwxvnb/IMG_1994.jpg?rlkey=9or7e1xmy15rhwnxxzzr6rlcc&st=6osfcz0m&raw=1"
    },
    "inethypereira": {
        desc: "Inethy & Carlos",
        img: "https://www.dropbox.com/scl/fi/z6mfppyynm7tnbhbzm18r/IMG_2000.JPG?rlkey=cp51b87bihc8o7d11uxevs18h&st=2816rfy6&raw=1"
    }
}